export const FormConfig = {
  "/": {
    title: "like to win?",
    description:
      "Get the tools and strategies to transform your hobby craft into a profitable creative business.",
    cols: ["$gForm1Col"],
    formId: "6412018",
  },
  "/newsletter": {
    title: "start small, start now",
    description:
      "Enter your email address and I will send you an Anti-Procrastination Planner (made in Notion) to help you beat procrastination.",
    formId: "6465660",
  },
  "/articles/*": {
    title: "Want more like this?",
    description:
      "Subscribe and get more actionable ideas straight to your inbox weekly that you can read for free.",
    cols: ["$gForm1Col"],
    formId: "6465665",
  },
};

export const getConfigForPath = (path, configMap, defaultConfig = {}) => {
  for (const route in configMap) {
    const pattern = new RegExp(`^${route.replace("*", ".*")}$`);
    if (pattern.test(path)) {
      return {
        ...defaultConfig,
        ...configMap[route],
        cols: configMap[route].cols || defaultConfig.cols, // fallback to defaultCols
      };
    }
  }
  return defaultConfig;
};
